import { createStructuredSelector } from "reselect";
import { selectAccountID } from "../../selectors/globalSelectors";

const getMessagingStates = (data) => data.messaging;

export const selectAdditionalAccountDetails = (state)=>{
  const { messages } = getMessagingStates(state);
  return messages.additionalAccountDetails;
}
export const selectAccountRole = (state) => {
  return selectAdditionalAccountDetails(state).accountRole;
}

export const getMessagesStates = (data) => {
  const { messages } = getMessagingStates(data);
  return messages;
};
export const selectMessagesData = (item) => {
  const { data } = getMessagesStates(item);
  return data;
}
export const selectAllmessagesData = (data) => {
  const { alldata } = getMessagesStates(data);
  return alldata;
}
export const selectSelected = (data) => {
  const { selected } = getMessagesStates(data);
  return selected;
}
export const selectCombinedMessagesData = (data) => {
  const { allMessages } = getMessagesStates(data);
  return allMessages;
}
export const selectIsToggle = (data) => {
  const { isToggle } = getMessagesStates(data);
  return isToggle;
}

export const messagesDerivedStates = createStructuredSelector({
  accountID: selectAccountID,
  messagesData: selectMessagesData,
  allmessagesData: selectAllmessagesData,
  selected: selectSelected,
  combinedMessagesData: selectCombinedMessagesData,
  isToggle: selectIsToggle
})




